export enum PORTAL_TYPES {
  GET_KNOWLEDGE_PORTAL_REQUEST = '@portal/GET_KNOWLEDGE_PORTAL_REQUEST',
  SET_DATA_KNOWLEDGE_PORTAL = '@portal/SET_DATA_KNOWLEDGE_PORTAL',
  SET_ERROR = '@portal/SET_ERROR',
}

export interface KnowledgePortals {
  response: any;
  message?: string;
}
export interface KnowledgePortalsState {
  portal: KnowledgePortals;
  error: string;
}

export interface GetKnowledgePortals {
  owner?: string;
}

export interface KnowledgePortal {
  id: string;
  fileType: string;
  owner: string;
  fileName: string;
  title: string;
  tag: string;
  createdAt: string;
}
